import numeral from "numeral";


export function priceFormat(price){
    return numeral(price).format('0.00') + ' €';
}